module.exports = __webpack_public_path__ + "img/var_02_safe.3cf198b5.png";